import {Roles} from './api/RoleApi';
import {IUserRoleEntity, RolesType} from './types';
export const SUPER_ADMIN_ROLE = 'super';
export const ADMIN_ROLE = 'admin';
export const PROJECT_ADMIN_ROLE = 'project-admin';
export const CONTRACTOR_ROLE = 'contractor';
export const READONLY_ROLE = 'readonly';

const {List, Read, Delete, Update, Create} = Roles.Permissions;

export default class AccessControl {
  static AdminRoles: RolesType[] = [SUPER_ADMIN_ROLE, ADMIN_ROLE, PROJECT_ADMIN_ROLE]
  static SuperAdminRole: RolesType = SUPER_ADMIN_ROLE;
  static RoleHelpText = {
    [SUPER_ADMIN_ROLE]: `Has access to entirety of application and can do any operation, do not use this role.`,
    [ADMIN_ROLE]: `Has access to all projects and most features and operations in the application. Use this role wisely.`,
    [PROJECT_ADMIN_ROLE]: 'PSA Administrator for only the projects assigned to the account.',
    [CONTRACTOR_ROLE]: 'Account for general contractor to manage sub-contractors.',
    [READONLY_ROLE]: 'Account for read only purposes, has access to all projects.'
  }

  static isAdminRole(role?: RolesType) {
    if (!role) return false;
    return AccessControl.AdminRoles.includes(role);
  }

  static isApplicationAdmin(role?: RolesType) {
    return AccessControl.SuperAdminRole === role;
  }

  public static hasRolePermissions(userRoles: IUserRoleEntity[], allowedRoles: string[]) {
    const roles = new Set<string>();
    userRoles.forEach((userRole) => {
      userRole.role.permissions.forEach((permission) => {
        const module = permission.applicationModule.name;
        const {create, read, update, delete: del, list} = permission;
        if (create) roles.add(`${module}:${Create}`);
        if (read) roles.add(`${module}:${Read}`);
        if (list) roles.add(`${module}:${List}`);
        if (update) roles.add(`${module}:${Update}`);
        if (del) roles.add(`${module}:${Delete}`);
      });
    });
    console.log(`User Permissions: ${Array.from(roles).join(', ')} limiting access to roles: ${allowedRoles.join(', ')}`);

    return allowedRoles.some((role) => roles.has(role));
  }
}

export enum RolesEnum {
  'super',
  'admin',
  'project-admin',
  'contractor',
  'readonly',
}
